import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import { ThemeProvider } from './context/ThemeContext'
import Landing      from './pages/Landing'
import Login        from './pages/Login'
import Signup       from './pages/Signup'
import Dashboard    from './pages/Dashboard'
import PDRCreate    from './pages/PDRCreate'
import PublicReport from './pages/PublicReport'   // ← new

function PrivateRoute({ children }) {
  const { session, loading } = useAuth()
  if (loading) return <p style={{ padding: '2rem', color: '#64748B' }}>Loading…</p>
  if (!session) return <Navigate to="/login" replace />
  return children
}

// Installed PWA (standalone) — skip the marketing landing entirely.
const isStandalone = typeof window !== 'undefined' &&
  (window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true)

function AppRoutes() {
  const { session, loading } = useAuth()
  if (loading) return null

  // Where a logged-out user lands on "/" : login in the app, landing on the web
  const home = session ? <Navigate to="/dashboard" replace /> : (isStandalone ? <Navigate to="/login" replace /> : <Landing />)
  const fallback = session ? '/dashboard' : (isStandalone ? '/login' : '/')

  return (
    <Routes>
      <Route path="/"              element={home} />
      <Route path="/login"         element={session ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/signup"        element={session ? <Navigate to="/dashboard" replace /> : <Signup />} />
      <Route path="/dashboard"     element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/pdr/new"       element={<PrivateRoute><PDRCreate /></PrivateRoute>} />
      <Route path="/report/:token" element={<PublicReport />} />  {/* public, no auth */}
      <Route path="*"              element={<Navigate to={fallback} replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}
